import { render, staticRenderFns } from "./ArticleFeatured.vue?vue&type=template&id=8cc8b76a&"
import script from "./ArticleFeatured.vue?vue&type=script&lang=js&"
export * from "./ArticleFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports